// to show buttons with actions on the table
import { lazy, Suspense } from "react";
import Button from '@/components/Button';

import { 
	Add as AddIcon, 
	Create as EditIcon, 
	Save as SaveIcon, 
	Delete as RemoveIcon,
	GetApp as ExportIcon,
	PictureAsPdf as PDFIcon,
	TableRows as CSVIcon,
	TableRows as ExcelIcon,
	Settings as ConfigIcon,
	Print as PrintIcon,
	Share as ShareIcon,
	FilterAlt as FilterIcon,
	FilterAltOff as FilterOffIcon,
	Person as AssignIcon,
	Refresh as RefreshIcon,
	Fullscreen as FullscreenIcon
} from '@mui/icons-material';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';

const TicketsButtons = lazy(() => import('@/pages/Tickets/TicketsButtons'));
const ResourcesGroupsButtons = lazy(() => import('@/pages/Resources/ResourcesGroupsButtons'));
const ResourcesButtons = lazy(() => import('@/pages/Resources/ResourcesButtons'));

export default function TableButtons({
	t,api,apiUrl,table,className,editable,modal,
	user,language,token,handleLogin,sendMessage,
	enableAdd,enableEdit,enableDelete,
	addDisabled,savedEnabled,editDisabled,shareDisabled,deleteDisabled,
	anchorEl,setAnchorEl,
	handleButtonShare,handleButtonExport,handleButtonAdd,
	handleButtonEdit,handleButtonDelete,handleButtonConfig,
	handleButtonRefresh,handleButtonFullscreen,fullScreen
}){

	return (
		<div className={className}>
			{
	        	table === 'tickets' &&
				<Suspense>
					<TicketsButtons
						t={t}
						user={user}
						language={language}
						apiUrl={apiUrl}
						api={api}
						token={token}
						handleLogin={handleLogin}
						sendMessage={sendMessage}
					/>
				</Suspense>
		    }
		    {
	        	table === 'resource_groups' &&
				<Suspense>
					<ResourcesGroupsButtons
						t={t}
						user={user}
						language={language}
						apiUrl={apiUrl}						
						token={token}
						handleLogin={handleLogin}
						sendMessage={sendMessage}
					/>
				</Suspense>
		    }
			{
	        	table === 'resources' &&
				<Suspense>
					<ResourcesButtons
						t={t}
						user={user}
						language={language}
						apiUrl={apiUrl}						
						token={token}
						handleLogin={handleLogin}
						sendMessage={sendMessage}
						fullScreen={fullScreen}
					/>
				</Suspense>
		    }
			<div className='flex justify-center items-center w-full max-md:grid max-md:grid-cols-12 my-4'>
	      		<>        		
	      		{
	      			(editable === true || enableAdd) &&          			
	          		<div className={'mx-1 max-md:my-1 max-md:col-span-4 max-md:text-center'}>
		          		<Button
		                    onClick={(e) => handleButtonAdd(e,'general')}
		                    className='ml-2'			                   
		                    //text={!modal && !editable && enableAdd && !enableEdit && savedEnabled ? t('actions.save.button') : t('actions.add.button')}
		                    icon={!modal && !editable && enableAdd && !enableEdit && savedEnabled ? <SaveIcon/> : <AddIcon/>}			                    
		                    disabled={addDisabled}
		                    type={!modal && !editable && enableAdd && !enableEdit && savedEnabled ? 'save' : 'add'}			                    
		                />
		            </div>
		        }
		        {
		        	(editable === true || enableEdit) &&  			
		            <div className={'mx-1 max-md:my-1 max-md:col-span-4 max-md:text-center'}>
		            	
		          		<Button           
		                    onClick={(e) => handleButtonEdit(e,'general',savedEnabled ? 'save' : 'edit')}
		                    //text={savedEnabled ? t('actions.save.button') : t('actions.edit.button')}
		                    disabled={editDisabled}
		                    type={savedEnabled ? 'save' : 'edit'}
		                    icon={savedEnabled ? <SaveIcon/> : <EditIcon/>}
		                />			                
		            </div>
		        }
		        {
		        	(editable === true || enableDelete) && 
		            <div className={'mx-1 max-md:my-1 max-md:col-span-4 max-md:text-center'}>
		            	
		          		<Button            
		                    onClick={(e) => handleButtonDelete(e,'general')}
		                    //text={t('actions.delete.button')}
		                    type="delete"
		                    variant="contained"
		                    disabled={deleteDisabled}
		                    icon={<RemoveIcon/>}
		                />
		            </div>		           
		        }	
		        </>	        

	            <div className={'mx-1 max-md:my-1 max-md:col-span-4 max-md:text-center'}>
	            	<Button          		            		
	                    onClick={(e) => setAnchorEl(e.currentTarget)}
	                    //text={t('actions.export.button')}
	                    type="export"
	                    variant="contained"		                    
	                    icon={<ExportIcon/>}
	                />	
	            	<Menu
	            		className='noprint'
	            		sx={{marginTop:0.2}}
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={() => setAnchorEl(null)}
					>
						<MenuItem 
							sx={{paddingRight:6.2}}
							onClick={() => handleButtonExport('csv')}
						>
							<ListItemIcon>
								<CSVIcon fontSize="small" />
	  						</ListItemIcon>
	  						<ListItemText>{t('actions.export.csv')}</ListItemText>
						</MenuItem>
						<MenuItem 
							sx={{paddingRight:6.2}}
							onClick={() => handleButtonExport('excel')}
						>
							<ListItemIcon>
								<ExcelIcon fontSize="small" />
	  						</ListItemIcon>
	  						<ListItemText>{t('actions.export.excel')}</ListItemText>
						</MenuItem>
						{/*
						<MenuItem 
							sx={{paddingRight:6.2}}
							onClick={() => handleButtonExport('pdf')}
						>
							<ListItemIcon>
								<PDFIcon fontSize="small" />
	  						</ListItemIcon>
	  						<ListItemText>{t('actions.export.pdf')}</ListItemText>
						</MenuItem>
						*/}
						<MenuItem 
							sx={{paddingRight:6.2}}
							onClick={() => handleButtonExport('print')}
						>
							<ListItemIcon>
								<PrintIcon fontSize="small" />
	  						</ListItemIcon>
	  						<ListItemText>{t('actions.export.print')}</ListItemText>
						</MenuItem>
					</Menu>
	            </div>	

	            <div className={'mx-1 max-md:my-1 max-md:col-span-4 max-md:text-center'}>
	          		<Button            
	                    onClick={(e) => handleButtonShare(e,'general')}
	                    //text={t('actions.share.button')}
	                    type="share"
	                    disabled={shareDisabled}
	                    icon={<ShareIcon/>}
	                />
	            </div>

	            <div className={'mx-1 max-md:my-1 max-md:col-span-4 max-md:text-center'}>
		            	
	          		<Button            
	                    onClick={handleButtonConfig}
	                    //text={t('actions.config.button')}
	                    type="config"
	                    icon={<ConfigIcon/>}
	                />
	            </div>

	            <div className={'mx-1 max-md:my-1 max-md:col-span-4 max-md:text-center'}>
		            	
	          		<Button            
	                    onClick={handleButtonRefresh}	                    
	                    type="refresh"
	                    icon={<RefreshIcon/>}
	                />
	            </div>

	            <div className={'mx-1 max-md:my-1 max-md:col-span-4 max-md:text-center'}>
		            	
	          		<Button            
	                    onClick={handleButtonFullscreen}	                    
	                    type="fullscreen"
	                    icon={<FullscreenIcon/>}	                    
	                />
	            </div>
	      	</div>
      	</div>
	);
}